<template>
<div class="label-development">
    <span>DESARROLLADO POR </span> <img :src="'img/pub/logo-az.png'" alt="Logo">
</div>
</template>
<script>
    export default {
        name: 'label-az-group',
    }
</script>
<style>
.label-development {
font-family: 'Gotham-Book',Arial, Helvetica, sans-serif;
  font-size: 0.8em;
  color: #444;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.label-development img {
  height: 2rem;
}
</style>